import { render, staticRenderFns } from "./EmailBroadcastMoreActions.vue?vue&type=template&id=23a72a52&scoped=true"
import script from "./EmailBroadcastMoreActions.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastMoreActions.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastMoreActions.vue?vue&type=style&index=0&id=23a72a52&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a72a52",
  null
  
)

export default component.exports